import Vue from 'vue'
import Router from 'vue-router'
import Loading from './views/Loading'
import Dashboard from './views/Dashboard.vue'
import Rules from './views/Rules.vue'
import User from './views/User.vue'
import UserBookings from './views/UserBookings.vue'
import UserHorses from './views/UserHorses.vue'
import Signup from './components/auth/Signup'
import Login from './components/auth/Login'
import ManageUsers from './views/ManageUsers'
import ManageBookings from './views/ManageBookings'
import AccountDisabled from './views/AccountDisabled'
import newVersion from './views/newVersion'
import Export from './views/Export'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'loading',
      component: Loading,
    },
    {
      path: 'newversion/',
      name: 'newversion',
      component: newVersion,
    },    
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
       }
    },    
    {
      path: '/rules',
      name: 'rules',
      component: Rules,
      meta: {
        requiresAuth: true
       }
    },
    {
      path: '/user',
      name: 'user',
      component: User,
      meta: {
        requiresAuth: true
       }
    },
    {
      path: '/userbookings',
      name: 'userbookings',
      component: UserBookings,
      meta: {
        requiresAuth: true
       }
    },
    {
      path: '/userhorses',
      name: 'userhorses',
      component: UserHorses,
      meta: {
        requiresAuth: true
       }
    },        
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/manageusers',
      name: 'manageusers',
      component: ManageUsers,
      meta: {
        requiresAuth: true
       }      
    },
    {
      path: '/managebookings',
      name: 'managebookings',
      component: ManageBookings,
      meta: {
        requiresAuth: true
       }      
    },   
    {
      path: '/export',
      name: 'export',
      component: Export,
      meta: {
        requiresAuth: true
       }      
    },            
    {
      path: '/accountdisabled',
      name: 'accountdisabled',
      component: AccountDisabled,
      meta: {
        requiresAuth: true
       }      
    }              
  ]
})
